// extracted by mini-css-extract-plugin
export default {"jobDetailsMainWrapper":"styles_jobDetailsMainWrapper__D8ymq","jobDetailsMain":"styles_jobDetailsMain__7oW0z","jobDetailPayment":"styles_jobDetailPayment__mqVX1"};